import { createFeatureSelector } from "@ngrx/store";

import { OrderProposalState } from "../models/order-proposal/order-proposal-state";
import { StoreKeys } from "../store-keys";

export class OrderProposalSelectors {
	static readonly orderProposals = createFeatureSelector<OrderProposalState>(
		StoreKeys.orderProposalStateKey
	);
}
